import { Button, Divider, Grid, Typography, useTheme } from "@mui/material";
import React, { useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Webcam from "react-webcam";
import Dropzone from "../../Components/Dropzone/Dropzone";
import { updateId2 } from "../../redux/user/userSlice";
import { API } from "../../utils/http";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
function _arrayBufferToBase64(buffer) {
	var binary = "";
	var bytes = new Uint8Array(buffer);
	var len = bytes.byteLength;
	for (var i = 0; i < len; i++) {
		binary += String.fromCharCode(bytes[i]);
	}
	return window.btoa(binary);
}
export default function IdUpload2(props) {
	const { handleNext, handleBack, renderControls, verifier } = props;
	const id2 = useSelector((state) => state.user.application.id2);
	const dispatch = useDispatch();
	const [error, setError] = useState({});
	const [hasChanged, setHasChanged] = useState(false);
	const personalInformation = useSelector((state) => state.user.application.personalInformation);
	const { t } = useTranslation();
	const theme = useTheme();
	const handleNextButton = () => {
		if (!hasChanged && id2.front && id2.back) {
			handleNext();
			return;
		}
		console.log("verify id: ", id2);
		const errors = verifier(id2);
		console.log(errors);
		if (Object.keys(errors).length == 0) {
			API.put("application", {
				id: personalInformation.id,
				pictures: [
					{
						type: "id2",
						front: id2.front,
						back: id2.back,
					},
				],
			})
				.then((r) => {
					toast.success(t("Successfully saved"));
					handleNext();
				})
				.catch((e) => {
					toast.error(t("Failed to save ID"));
				});
			setError({});
		} else {
			setError(errors);
		}
	};
	const onDropFront = useCallback(async (acceptedFiles) => {
		setHasChanged(true);
		console.log(acceptedFiles);
		const buffer = await acceptedFiles[0].arrayBuffer();
		const payload = {
			front: `data:image/png;base64,${_arrayBufferToBase64(buffer)}`,
		};
		dispatch(updateId2(payload));
	}, []);
	const onDropBack = useCallback(async (acceptedFiles) => {
		setHasChanged(true);
		console.log(acceptedFiles);
		const buffer = await acceptedFiles[0].arrayBuffer();
		const payload = {
			back: `data:image/png;base64,${_arrayBufferToBase64(buffer)}`,
		};
		dispatch(updateId2(payload));
	}, []);
	const clearIdFront = () => {
		const payload = {
			front: "",
		};
		dispatch(updateId2(payload));
	};
	const clearIdBack = () => {
		const payload = {
			back: "",
		};
		dispatch(updateId2(payload));
	};
	return (
		<React.Fragment>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					{/* <Typography>
            To confirm your identity, we need to compare the picture from your
            identity document to a photo you will take of yourself. Do you agree
            to the following statement?
          </Typography>
          <Typography>
            I understand and consent freely that my picture will be collected
            and processed on behalf of Police Certs via a biometric system based
            on facial recognition technology to identify me in photographs for
            the purposes of verifying my identity as part of my application.
          </Typography> */}
				</Grid>

				<Grid item xs={12}>
					<Divider></Divider>
				</Grid>
				<Grid item xs={12} sm={6} textAlign="center">
					<Dropzone
						onDrop={onDropFront}
						accept={{ "image/jpeg": [".jpeg", ".jpg"] }}
						maxFiles={1}
						file={id2.front}
						clearFile={clearIdFront}
						description={t("Upload Front")}
					/>
					<Typography
						sx={{
							display: error.front ? "block" : "none",
							color: theme.palette.error.main,
						}}
					>
						{error.front}
					</Typography>
				</Grid>
				<Grid item xs={12} sm={6} textAlign="center">
					<Dropzone
						onDrop={onDropBack}
						accept={{ "image/jpeg": [".jpeg", ".jpg"] }}
						maxFiles={1}
						file={id2.back}
						clearFile={clearIdBack}
						description={t("Upload Back")}
					/>
					<Typography
						sx={{
							display: error.back ? "block" : "none",
							color: theme.palette.error.main,
						}}
					>
						{error.back}
					</Typography>
				</Grid>
			</Grid>
			{renderControls(handleNextButton, handleBack)}
		</React.Fragment>
	);
}
